import { connect } from 'react-redux'
import CurrentTable from './current-table'
import { getInvitationsList } from '../../../../../stores/current-invitations/current-invitations.selectors'

const mapStateToProps = state => ({
  invitations: getInvitationsList(state)
})

export default connect(mapStateToProps, null)(CurrentTable)
